<template>
  <footer class="footer">
    <v-row class="CustomContainer" no-gutters>
      <v-col class="pa-4 px-lg-10" md="3" cols="12">
        <logo type="portrait" :name="$t('brand.name')" />
        <p v-if="isDesktop" class="body-2 text-center primary--text">
          &copy;&nbsp;
          {{ $t("brand.footerText") }}
        </p>
      </v-col>
      <v-col class="pa-4" md="6" cols="12">
        <v-expansion-panels v-if="isMobile">
          <v-expansion-panel v-for="(footer, index) in footers" :key="index" class="accordion-content">
            <v-expansion-panel-header>
              <h6 class="title mb-4 primary--text">{{ $t(footer.title) }}</h6>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <ul>
                <li v-for="(item, index) in footer.description" :key="index">
                  <a
                    v-if="isExternalLink(footer.link[index])"
                    :href="footer.link[index]"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="footer-link"
                    :title="$t(item)"
                  >{{ $t(item) }}</a>
                  <nuxt-link
                    v-else
                    :to="localePath(footer.link[index])"
                    class="footer-link"
                    :title="$t(item)"
                  >{{ $t(item) }}</nuxt-link>
                </li>
              </ul>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <v-row v-if="isDesktop" justify="space-around">
          <v-col v-for="(footer, index) in footers" :key="index" class="pa-4 site-map-item">
            <h6 class="title mb-4 primary--text">{{ $t(footer.title) }}</h6>
            <ul>
              <li v-for="(item, index) in footer.description" :key="index">
                <a
                  v-if="isExternalLink(footer.link[index])"
                  :href="footer.link[index]"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="footer-link"
                  :title="$t(item)"
                >{{ $t(item) }}</a>
                <nuxt-link
                  v-else
                  :to="localePath(footer.link[index])"
                  class="footer-link"
                  :title="$t(item)"
                >{{ $t(item) }}</nuxt-link>
              </li>
            </ul>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="3" cols="12" class="pa-4">
        <div class="socmed">
          <v-btn text icon class="button" color="primary" target="_blank"
            href="https://www.facebook.com/motanamy.software">
            <span class="mdi mdi-facebook icon" />
          </v-btn>
          <v-btn text icon class="button" color="primary" target="_blank" href="https://wa.me/message/7ESXA4SVCYVUP1">
            <span class="mdi mdi-whatsapp icon" />
          </v-btn>
          <v-btn text icon class="button" color="primary" target="_blank" href="https://t.me/MotanamySupport_bot" aria-label="Telegram">
            <svg class="telegram-icon" viewBox="0 0 24 24" width="22" height="22" fill="currentColor" style="display: inline-block; vertical-align: middle;">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.64 6.8c-.15 1.58-.8 5.42-1.13 7.19-.14.75-.42 1-.68 1.03-.58.05-1.02-.38-1.58-.75-.88-.58-1.38-.94-2.23-1.5-.99-.65-.35-1.01.22-1.59.15-.15 2.71-2.48 2.76-2.69a.2.2 0 00-.05-.18c-.06-.05-.14-.03-.21-.02-.09.02-1.49.95-4.22 2.79-.4.27-.76.41-1.08.4-.36-.01-1.04-.2-1.55-.37-.63-.2-1.12-.31-1.08-.66.02-.18.27-.36.74-.55 2.92-1.27 4.86-2.11 5.83-2.51 2.78-1.16 3.35-1.36 3.73-1.36.08 0 .27.02.39.12.1.08.13.19.14.27-.01.06.01.24 0 .38z"/>
            </svg>
          </v-btn>
          <v-btn text icon class="button" color="primary" target="_blank"
            href="https://www.linkedin.com/company/motanamy/">
            <span class="mdi mdi-linkedin icon" />
          </v-btn>
        </div>
        <v-select :items="langList" :value="lang" v-model="lang" @change="switchLang(lang)" color="primary" outlined
          class="select-lang primary--text" />
        <p v-if="isMobile" class="body-2 text-center">
          &copy;&nbsp;
          {{ $t("brand.footerText") }}
        </p>
      </v-col>
    </v-row>
    <div class="footer_bg">
      <div class="footer_bg_one"></div>
      <div class="footer_bg_two"></div>
    </div>
    <whatsapp-contact />
  </footer>
</template>

<style scoped lang="scss">
@import "./footer-sitemap";
</style>

<script>
import Logo from "../Logo";
import WhatsAppContact from "@/components/WhatsAppContact";

export default {
  components: {
    Logo,
    "whatsapp-contact": WhatsAppContact
  },
  data: () => ({
    lang: "en",
    footers: [
      {
        title: "header.company",
        description: [
          "header.team",
          "header.about",
          "header.policy",
          "header.usage"
        ],
        link: ["/about/team", "/about", "/policy/privacy", "/policy/usage"]
      },
      {
        title: "header.services",
        description: [
          "services[0].title",
          "services[1].title",
          "services[2].title",
          "services[3].title"
        ],
        link: [
          "/services/mobile",
          "/services/website",
          "/services/desktop",
          "/services/plugin"
        ]
      },
      {
        title: "header.links",
        description: [
          "header.portfolio",
          "header.blog",
          "header.faq_title",
          "header.contact"
        ],
        link: ["/#portfolio", "/bloger", "/faq", "/contact"]
      }
    ]
  }),
  mounted() {
    this.lang = this.$i18n.locale;
  },
  computed: {
    langList: function () {
      const list = [];
      this.$i18n.locales.map(item => {
        list.push({ text: this.$t("lang." + item.code), value: item.code });
      });
      return list;
    },
    isMobile() {
      const mdDown = this.$store.state.breakpoints.mdDown;
      return mdDown.indexOf(this.$mq) > -1;
    },
    isDesktop() {
      const lgUp = this.$store.state.breakpoints.lgUp;
      return lgUp.indexOf(this.$mq) > -1;
    }
  },
  methods: {
    switchLang: function (val) {
      this.$i18n.setLocale(val);
    },
    isExternalLink(link) {
      return /^https?:\/\//.test(link);
    }
  }
};
</script>
